<template>
  <div v-if="page.clients" class="page page-dark page-clients">
    <div class="container">
      <div v-html="page.clients.text_lead_dark" class="lead lead-intro col-md-12"/>
      <div class="col-md-12">
        <h1>{{ page.clients.name }}</h1>
      </div>
      <div class="slider-service">
        <Slider :dark="true"/>
      </div>
  </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Slider from '@/components/SliderBig';

require('@/assets/css/swiper.css');

export default {
  name: 'clientsDark',
  components: {
    Slider,
  },
  computed: mapGetters({
    page: 'page',
  }),
};
</script>


<style>
.page{
  &-clients{

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ClientsDark.vue